
import DOMPurify from 'dompurify';
import { useEffect, useRef } from 'react';

function InnerHtml(props: {className: string, text: string}) {
  const divRef = useRef<any>();
  useEffect(() => {
    divRef.current.innerHTML = DOMPurify.sanitize(props.text);
  }, [props.text])

  return (
    <div ref={divRef} className={props.className}/>
  );
}

export default InnerHtml;
